const isDarkMode = true;

export const palette = {
    primary: '#525fd3',
    secondary: '#6495ed',
    warning: '#db2c00',
    safe: '#8373f0',
    white: !isDarkMode ? '#ffffff' : '#161616',
    black: !isDarkMode ? '#242424' : '#f4f4f4',
    fixedWhite: '#f4f4f4',
    fixedBlack: '#242424',
    borderColor: !isDarkMode ? '#ebebeb' : '#2d2d2d',
    darkGray: !isDarkMode ? '#4d4d4d' : '#959595',
    gray: !isDarkMode ? '#868686' : '#505050',
    lightGray: !isDarkMode ? '#e6e6e6' : '#454545',
    lightGray2: !isDarkMode ? '#dcdcdc' : '#5f5f5f',
    lightGray3: !isDarkMode ? '#b1b1b1' : '#686868',
    lightGray4: !isDarkMode ? '#989898' : '#818181',
    offWhite: !isDarkMode ? '#f4f4f4' : '#1d1d1d',
};